<template>
  <div class="notice-container" v-if="content">
    <div
      v-for="(section, sIndex) in sections"
      :key="sIndex"
      class="notice-section"
    >
      <span class="notice-title">{{ section.title }}</span>
      <template v-for="(part, pIndex) in section.parts">
        <span
          :key="pIndex"
          :class="{ 'notice-highlight': part.highlight }"
        >{{ part.text }}</span>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoticeHighlight',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  computed: {
    sections() {
      if (!this.content) return []
      var lines = this.content.split('\n')
      var sections = []
      var currentSection = null

      for (var i = 0; i < lines.length; i++) {
        var line = lines[i]
        var titleMatch = line.match(/^#(.+)#$/)
        if (titleMatch) {
          if (currentSection) {
            sections.push(currentSection)
          }
          currentSection = {
            title: titleMatch[1],
            parts: []
          }
        } else if (currentSection && line.trim()) {
          var parts = this.parseContent(line)
          currentSection.parts = currentSection.parts.concat(parts)
        }
      }
      if (currentSection) {
        sections.push(currentSection)
      }
      return sections
    }
  },
  methods: {
    parseContent(text) {
      var parts = []
      var regex = /#([^#]+)#/g
      var lastIndex = 0
      var match

      while ((match = regex.exec(text)) !== null) {
        if (match.index > lastIndex) {
          parts.push({
            text: text.substring(lastIndex, match.index),
            highlight: false
          })
        }
        parts.push({
          text: match[1],
          highlight: true
        })
        lastIndex = regex.lastIndex
      }
      if (lastIndex < text.length) {
        parts.push({
          text: text.substring(lastIndex),
          highlight: false
        })
      }
      return parts
    }
  }
}
</script>

<style scoped>
.notice-section {
    line-height: 1.2;
}
.notice-section:last-child {
  margin-bottom: 0;
}
.notice-title {
  color: #71524a;
  font-size: 13px;
  font-weight: bold;
  margin-right: 4px;
}
.notice-section .notice-highlight {
  color: #71524a;
  font-weight: 500;
}
.notice-section span{
    font-size: 13px;
    color: #000;
}
</style>